<div class="container home-content">
  <section class="hero">
    <h1>Welcome to Talespinner</h1>
    <h2>Crafting tales with AI that resonate with your individual style.</h2>
    <p class="description">
      At Talespinner, we blend the power of technology with the timeless art of storytelling. Here, your ideas, both grand and subtle, are transformed into compelling tales. Dive deep into a space that's both intuitive and inspiring, and together, let's spin tales that touch hearts and ignite imaginations.
    </p>
    <a href="/account/signup" class="btn btn-primary" *ngIf="!userIsLoggedIn">Get Started</a>
    <a href="/dashboard" class="btn btn-primary" *ngIf="userIsLoggedIn">Start Writing</a>
    <a href="/discover" class="btn btn-secondary">Explore Books</a>
  </section>

  <section class="features-overview">
    <div class="feature-grid">
      <div class="feature-item">
        <i class="fas fa-robot"></i>
        <h3>Advanced AI Models</h3>
        <p>Access multiple frontier models like Claude, GPT-4, Command R+, and Mistral Large.</p>
      </div>
      <div class="feature-item">
        <i class="fas fa-language"></i>
        <h3>Multilingual Support</h3>
        <p>Write in any language and even provide instructions in your native tongue.</p>
      </div>
      <div class="feature-item">
        <i class="fas fa-feather-alt"></i>
        <h3>Customizable Writing</h3>
        <p>Define your unique writing style, genre, and narrative structure.</p>
      </div>
      <div class="feature-item">
        <i class="fas fa-users"></i>
        <h3>Character Development</h3>
        <p>Create deep, evolving characters with detailed backgrounds and personalities.</p>
      </div>
    </div>
  </section>
</div>
